/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const reply = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.389 3.028a1 1 0 0 0-1.733-.678L1.015 6.292a1 1 0 0 0 0 1.356l3.639 3.943a1 1 0 0 0 1.733-.679V8.97h4a5 5 0 0 1 5 5v-4a5 5 0 0 0-5-5h-4l.002-1.942Z"
      clipRule="evenodd"
    />
  </svg>
)
export default reply
